export const STATUS_PROGRESS_LOADING = {
  NONE: 'NONE',
  START: 'START',
  FINISH: 'FINISH'
}

export const STATUS_PROCESS_OBV = {
  NONE: 'NONE',
  INIT: 'INIT',
  LINK_TOKEN_CREATED: 'LINK_TOKEN_CREATED',
  CREATED_PLAID_LINK: 'CREATED_PLAID_LINK',
  LINK_TOKEN_GRANTED: 'LINK_TOKEN_GRANTED',
  LINK_TOKEN_FAILURE: 'LINK_TOKEN_FAILURE',
  ACCESS_TOKEN_ACQUIRED: 'ACCESS_TOKEN_ACQUIRED',
  ACCESS_TOKEN_REVALIDATED: 'ACCESS_TOKEN_REVALIDATED',
  IDENTITY_VERIFICATION_SUCCESS: 'IDENTITY_VERIFICATION_SUCCESS',
  IDENTITY_QUERY_SUCCESS: 'IDENTITY_QUERY_SUCCESS',
  IDENTITY_VERIFICATION_FAILURE: 'IDENTITY_VERIFICATION_FAILURE',
  BALANCE_VERIFICATION_SUCCESS: 'BALANCE_VERIFICATION_SUCCESS',
  BALANCE_VERIFICATION_FAILURE: 'BALANCE_VERIFICATION_FAILURE',
  OBV_TOKEN_GRANTED: 'OBV_TOKEN_GRANTED',
  CONTINUE_OAUTH_CALLBACK_SUCCESS: "CONTINUE_OAUTH_CALLBACK_SUCCESS",
}

export const STATUS_PROCESS_OBV_VERIFICATION_SUCCESS = [
  STATUS_PROCESS_OBV.ACCESS_TOKEN_REVALIDATED,
  STATUS_PROCESS_OBV.IDENTITY_VERIFICATION_SUCCESS
];

export const PLAID_EVENT_VIEW_NAME = {
  CONSENT: 'CONSENT',
  LOADING: 'LOADING',
  CREDENTIAL: 'CREDENTIAL',
  CONNECTED: 'CONNECTED',
  ERROR: 'ERROR',
  EXIT: 'EXIT',
  MATCHED_CONSENT: 'MATCHED_CONSENT',
  MATCHED_CREDENTIAL: 'MATCHED_CREDENTIAL',
  MATCHED_MFA: 'MATCHED_MFA',
  MFA: 'MFA',
  NUMBERS: 'NUMBERS',
  RECAPTCHA: 'RECAPTCHA',
  SELECT_ACCOUNT: 'SELECT_ACCOUNT',
  SELECT_BRAND: 'SELECT_BRAND',
  SELECT_INSTITUTION: 'SELECT_INSTITUTION',
}

export const PLAID_EVENT_VIEW_NAME_FOOTER = [
  PLAID_EVENT_VIEW_NAME.CONSENT,
  PLAID_EVENT_VIEW_NAME.MATCHED_CONSENT,
  PLAID_EVENT_VIEW_NAME.SELECT_INSTITUTION,
];

export const PLAID_EVENT_NAME = {
  OPEN: 'OPEN',
  TRANSITION_VIEW: 'TRANSITION_VIEW',
  SELECT_INSTITUTION: 'SELECT_INSTITUTION',
  SUBMIT_CREDENTIALS: 'SUBMIT_CREDENTIALS',
  HAND_OFF: 'HANDOFF',
  CLOSE_OAUTH: 'CLOSE_OAUTH',
  ERROR: 'ERROR',
  EXIT: 'EXIT',
  FAIL_OAUTH: 'FAIL_OAUTH',
  MATCHED_SELECT_INSTITUTION: 'MATCHED_SELECT_INSTITUTION',
  MATCHED_SELECT_VERIFY_METHOD: 'MATCHED_SELECT_VERIFY_METHOD',
  OPEN_MY_PLAID: 'OPEN_MY_PLAID',
  OPEN_OAUTH: 'OPEN_OAUTH',
  SEARCH_INSTITUTION: 'SEARCH_INSTITUTION',
  SUBMIT_MFA: 'SUBMIT_MFA',
}

export const PLAID_EXIT_ERROR_CODE = {
  ITEM_NO_ERROR: 'item-no-error',
}

export const PLAID_STATUS_INIT = {
  INIT: 'INIT',
  INITIALIZED: 'INITIALIZED',
  HIDE: 'HIDE'
}
